import { ServiceBase } from '../../../../../core/services/ServiceBase'
import ReportProxy, { FinancialStatementProxy } from './ReportProxy'

class ReportService extends ServiceBase {
  getSampleReport(params) {
    return this.getFileDownload(() => ReportProxy.getSampleReport(params))
  }

  getReportItem(params) {
    return this.getData(() => ReportProxy.getReportItem(params))
  }

  getReportSources(params) {
    return this.getData(() => ReportProxy.getReportSources(params))
  }

  getFiinGateReportTypes(params) {
    return this.getData(() => ReportProxy.getFiinGateReportTypes(params))
  }

  getDataAvailability(params) {
    return this.getData(() =>
      FinancialStatementProxy.getDataAvailability(params),
    )
  }
}

export default new ReportService()
